"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useUtilityClasses = exports.getQuantityPickerSlots = exports.TooltipContainer = exports.TooltipArrow = exports.QuantityPickerRoot = exports.InputRoot = exports.IconButtonRoot = void 0;
var _react = require("@floating-ui/react");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _IconButton = _interopRequireWildcard(require("../IconButton"));
var _utils = require("../utils");
var _constants = require("./constants");
var _quantityPickerClasses = require("./quantityPickerClasses");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
var getQuantityPickerSlots = function(ownerState) {
    var disabled = ownerState.disabled, focused = ownerState.focused, readOnly = ownerState.readOnly, size = ownerState.size, variant = ownerState.variant;
    return {
        root: [
            'root',
            disabled && 'disabled',
            readOnly && 'readOnly',
            "".concat(variant).concat((0, _utils.capitalize)(size))
        ],
        input: [
            'input',
            focused && 'focused',
            "size".concat((0, _utils.capitalize)(size))
        ],
        iconButton: [
            'iconButton',
            "".concat(variant).concat((0, _utils.capitalize)(size))
        ],
        increaseButton: [
            'increaseButton'
        ],
        decreaseButton: [
            'decreaseButton'
        ]
    };
};
exports.getQuantityPickerSlots = getQuantityPickerSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getQuantityPickerSlots(ownerState);
    return (0, _base.unstable_composeClasses)(slots, _quantityPickerClasses.getQuantityPickerUtilityClass, classes);
};
exports.useUtilityClasses = useUtilityClasses;
var QuantityPickerRoot = exports.QuantityPickerRoot = (0, _material.styled)('div', {
    name: 'MuiOriQuantityPicker',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            ownerState.disabled && styles.disabled,
            ownerState.readOnly && styles.readOnly,
            styles["".concat(ownerState.variant).concat((0, _utils.capitalize)(ownerState.size))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread(_object_spread_props(_object_spread({
        display: 'grid',
        gridTemplateColumns: ownerState.cssProps.holder.gridTemplateColumns,
        justifyContent: 'space-between',
        alignContent: 'space-around',
        boxSizing: 'border-box',
        minWidth: ownerState.cssProps.holder.minWidth,
        width: ownerState.cssProps.holder.width,
        height: ownerState.cssProps.holder.height,
        minHeight: _constants.TEXT_MEDIUM_BUTTON_SIZE
    }, ownerState.variant === 'contained' && ownerState.size === 'medium' && {
        minHeight: _constants.CONTAINED_MEDIUM_BUTTON_MIN_HEIGHT
    }, ownerState.variant === 'contained' && ownerState.size === 'large' && {
        minHeight: _constants.CONTAINED_LARGE_BUTTON_MIN_HEIGHT
    }), {
        overflow: 'hidden',
        background: ownerState.cssProps.holder.background,
        padding: ownerState.cssProps.holder.padding,
        borderRadius: ownerState.cssProps.holder.borderRadius,
        boxShadow: ownerState.cssProps.holder.boxShadow
    }), ownerState.expandOnFocus && _object_spread({
        gridTemplateColumns: '0 3.4rem 0',
        minHeight: '2.6rem',
        transition: theme.transitions.create([
            'width',
            'translate'
        ], {
            duration: theme.transitions.duration.short
        })
    }, ownerState.focused && {
        gridTemplateColumns: '2.6rem 3.4rem 2.6rem',
        minWidth: '10.2rem',
        width: '10.2rem'
    }));
});
var InputRoot = exports.InputRoot = (0, _material.styled)(_material.InputBase, {
    name: 'MuiOriQuantityPicker',
    slot: 'Input',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.input,
            ownerState.focused && styles.focused,
            styles["size".concat((0, _utils.capitalize)(ownerState.size))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread(_object_spread_props(_object_spread({
        margin: 0,
        padding: 0,
        minWidth: ownerState.cssProps.input.minWidth,
        width: ownerState.cssProps.input.width,
        height: ownerState.cssProps.input.height,
        transition: theme.transitions.create([
            'border'
        ], {
            duration: theme.transitions.duration.short
        }),
        border: '1px solid transparent',
        borderRadius: theme.shape.mediumComponentRadius,
        alignSelf: 'center',
        fontSize: _constants.INPUT_FONT_SIZE,
        '&:hover': {
            border: "1px solid ".concat(theme.palette.grey[200]),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderColor: theme.palette.grey[200]
            }
        }
    }, ownerState.focused && {
        border: "1px solid ".concat(theme.palette.grey[200])
    }, ownerState.readOnly && {
        border: 'none'
    }), _define_property({}, "& input", _object_spread({
        fontSize: _constants.INPUT_FONT_SIZE,
        textAlign: 'center',
        padding: 0
    }, ownerState.readOnly && {
        cursor: 'default'
    }))), ownerState.disabled && {
        color: theme.palette.text.disabled,
        borderColor: 'transparent'
    });
});
var IconButtonRoot = exports.IconButtonRoot = (0, _material.styled)(_IconButton.default, {
    name: 'MuiOriQuantityPicker',
    slot: 'iconButton',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.iconButton,
            styles["".concat(ownerState.variant).concat((0, _utils.capitalize)(ownerState.size))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        fontSize: ownerState.cssProps.button.fontSize,
        width: ownerState.cssProps.button.width,
        height: ownerState.cssProps.button.height
    }, ownerState.tooltipTrigger && _define_property({
        background: 'transparent',
        color: theme.palette.grey.A400,
        cursor: 'default',
        '&:hover': {
            background: 'transparent !important',
            color: "".concat(theme.palette.grey.A400, " !important")
        },
        '&:focus': {
            background: 'transparent !important',
            color: "".concat(theme.palette.grey.A400, " !important")
        }
    }, "&.".concat(_IconButton.iconButtonClasses.focusVisible), {
        background: 'transparent',
        color: theme.palette.grey.A400
    }), ownerState.expandOnFocus && _object_spread({
        display: 'none'
    }, ownerState.focused && {
        display: 'initial',
        lineHeight: 0.75
    }));
});
var TooltipContainer = exports.TooltipContainer = (0, _material.styled)('div')(function(param) {
    var theme = param.theme;
    return {
        boxSizing: 'border-box',
        padding: theme.spacing(4),
        maxWidth: 200,
        margin: 0,
        background: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.text.primary,
        fontSize: theme.typography.body1.fontSize,
        boxShadow: theme.shadows[3]
    };
});
var TooltipArrow = exports.TooltipArrow = (0, _material.styled)(_react.FloatingArrow)(function(param) {
    var theme = param.theme;
    return {
        fill: theme.palette.common.white
    };
}); //# sourceMappingURL=quantityPickerStyled.js.map
